// Dev-only logger: silent in production builds so console noise never ships.
const isDev = process.env.NODE_ENV !== "production";
const noop = () => {};

export const log = {
  debug: isDev ? (...a) => console.debug(...a) : noop,
  warn: isDev ? (...a) => console.warn(...a) : noop,
  error: isDev ? (...a) => console.error(...a) : noop,
};
